module.exports = __webpack_public_path__ + "static/media/video-end-v-commerce.d6adddbc.mp4";